import Section from "./Section";
import {H1, H2} from "../Headlines";
import Paragraph from "../Paragraph";
import React from "react";

export default function Impressum() {
    return <>
        <Section id={'impressum'} className={'!pt-0 text-left'}>
            <H1 id={'impressum-headline'}>Impressum</H1>
            <Intro/>
            <Kontakt/>
            <VertretenDurch/>
            <UmsatzsteuerId/>
            <BerufsrechtlicheAngaben/>
            <HaftungFuerInhalte/>
            <HaftungFuerLinks/>
            <Urheberrecht/>
        </Section>
    </>
}

function Intro() {
    return <>
        <H2 id={'impressum-intro'} className={'mt-8'}>Angaben gemäß § 5 Telemediengesetz</H2>
        <Paragraph className={"mt-8"}>
            OMW Energieberatungsbüro GbR<br/>
            Tobias Michael-Weber und Benedikt Oppermann<br/>
            Gesellschaft bürgerlichen Rechts<br/>
            Rhönblick 9<br/>
            63579 Freigericht
        </Paragraph>
    </>
}

function Kontakt() {
    return <>
        <H2 id={'impressum-kontakt'} className={'mt-8'}>Kontakt</H2>
        <Paragraph className={"mt-8"}>
            Telefon: 0176-20272987<br/>
            E-Mail: benedikt.oppermann@omw-energieberatungsbuero.de<br/>
            Website: www.omw-energieberatung.de
        </Paragraph>
    </>
}

function VertretenDurch() {
    return <>
        <H2 id={'impressum-vertreten-durch'} className={'mt-8'}>Vertreten durch</H2>
        <Paragraph className={"mt-8"}>
            Tobias Michael-Weber und Benedikt Oppermann
        </Paragraph>
    </>
}

function UmsatzsteuerId() {
    return <>
        <H2 id={'impressum-umsatzsteuer-id'} className={'mt-8'}>Umsatzsteuer-ID</H2>
        <Paragraph className={"mt-8"}>
            Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz: DE365439193
        </Paragraph>
    </>
}

function BerufsrechtlicheAngaben() {
    return <>
        <H2 id={'impressum-berufsrechtliche-angaben'} className={'mt-8'}>Berufsrechtliche Angaben (falls
            zutreffend)</H2>
        <Paragraph className={"mt-8"}>
            Berufsbezeichnung: Gebäudeenergieberater (HWK)<br/>
            Verliehen in: Handwerkskammer Erfurt
        </Paragraph>
    </>
}

function HaftungFuerInhalte() {
    return <>
        <H2 id={'impressum-haftung-fuer-inhalte'} className={'mt-8'}>Haftung für Inhalte</H2>
        <Paragraph className={"mt-8"}>
            Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach
            den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als
            Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde
            Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige
            Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
            Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine
            diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten
            Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen
            werden wir diese Inhalte umgehend entfernen.
        </Paragraph>
    </>
}

function HaftungFuerLinks() {
    return <>
        <H2 id={'impressum-haftung-fuer-links'} className={'mt-8'}>Haftung für Links</H2>
        <Paragraph className={"mt-8"}>
            Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen
            Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr
            übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder
            Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der
            Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum
            Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der
            verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht
            zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links
            umgehend entfernen.
        </Paragraph>
    </>
}

function Urheberrecht() {
    return <>
        <H2 id={'impressum-urheberrecht'} className={'mt-8'}>Urheberrecht</H2>
        <Paragraph className={"mt-8"}>
            Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen
            dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art
            der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen
            Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind
            nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser
            Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet.
            Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um
            einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir
            derartige Inhalte umgehend entfernen.
        </Paragraph>
    </>
}